var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BReporting } from "sb-data-layer";
import { action, observable } from "mobx";
export class BettingHistoryStorage {
    constructor() {
        this.data = [];
        this.betPosition = new Map();
    }
    add(item) {
        let array = [];
        let length = this.data.length;
        item.bets.forEach(bet => {
            let betIndex = this.betPosition.get(bet.betId);
            if (betIndex !== undefined) {
                if (!this.areEqual(this.data[betIndex], bet)) {
                    this.data[betIndex] = bet;
                }
            }
            else {
                this.betPosition.set(bet.betId, length++);
                array.push(bet);
            }
        });
        this.data.push.apply(this.data, array);
    }
    getItem(key) {
        let betIndex = this.betPosition.get(key);
        if (betIndex !== undefined) {
            return this.data[betIndex];
        }
        return;
    }
    areEqual(bet, otherBet) {
        return JSON.stringify(bet) === JSON.stringify(otherBet);
    }
    remove(key) {
        let betIndex = this.betPosition.get(key);
        if (betIndex !== undefined) {
            this.data.splice(betIndex, 1);
            this.betPosition.delete(key);
        }
    }
}
__decorate([
    observable.shallow,
    __metadata("design:type", Array)
], BettingHistoryStorage.prototype, "data", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BettingHistoryStorage.prototype, "add", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], BettingHistoryStorage.prototype, "remove", null);
export const BettingHistoryStorageInstance = new BettingHistoryStorage();
//# sourceMappingURL=BettingHistoryStorage.js.map